import { actionsMain } from './actionsMain';
import { getters } from './getters';
import { mutations } from './mutations';
import { MainState } from './state';
import { getDefaultLocale } from '@/lib/locales';

const defaultState: MainState = {
  initialized: false,
  forceEnroll2Fa: false,
  company: null,
  switchableCompanies: [],
  departments: null,
  userProfile: null,
  dashboardMiniDrawer: false,
  dashboardShowDrawer: true,
  notifications: [],
  nonLoggedInUserLocale: getDefaultLocale(), // Initialize with default locale
  featureFlags: {},
  pollingIntervalOfFeatureFlags: null,
};

export const mainModule = {
  state: defaultState,
  mutations,
  actions: { ...actionsMain },
  getters,
};
